import { Fragment, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Taptop from './TapTop';
import Header from './Header';
import Sidebar from './Sidebar';
import Loader from './Loader';

/**
 * Cáscara del panel: barra lateral fija + columna principal con la barra
 * superior de 70px y el contenido.
 *
 * Ya no usa las clases de la plantilla Cuba (page-wrapper / sidebar-wrapper
 * / page-body): su CSS posiciona la barra lateral en `fixed` con anchos y
 * offsets propios, que peleaban con el `sticky` del diseño nuevo. El
 * ThemeCustomizer y el footer de la plantilla quedan fuera del layout —
 * los archivos siguen ahí, sin importar.
 *
 * `drawer` es el único estado que comparten barra superior (botón de menú)
 * y barra lateral (cajón y pestaña "Menú"); por eso vive aquí y no en un
 * contexto.
 */
const AppLayout = () => {
  const [drawer, setDrawer] = useState(false);

  return (
    <Fragment>
      <Loader />
      <Taptop />
      <div className="ui-shell">
        <Sidebar open={drawer} setOpen={setDrawer} />
        <div className="ui-main">
          <Header onMenu={() => setDrawer(true)} />
          <div className="ui-content">
            <Outlet />
          </div>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default AppLayout;
